var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconVideoSolid extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconVideo",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M746.667 1374.31V545.935l690.346 414.187-690.346 414.186ZM1879.04 321.615c-600.107-143.467-1238.4-143.467-1838.08 0L0 331.429v1257.494l40.96 9.813c300.053 71.68 609.28 108.053 919.04 108.053 309.867 0 619.2-36.373 919.04-108.053l40.96-9.813V331.429l-40.96-9.813Z",
      fillRule: "evenodd"
    })));
  }
}
IconVideoSolid.glyphName = 'video';
IconVideoSolid.variant = 'Solid';
IconVideoSolid.displayName = 'IconVideoSolid';
IconVideoSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconVideoSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconVideoSolid;
export { IconVideoSolid };